import { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { RefreshCcw, SlidersHorizontal, X
} from 'lucide-react';
import { FaTwitter, FaInstagram, FaTiktok, FaFilter, FaAngleDown } from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";


// components
import BackDrop from "../components/backdrop";
import UpdateInfo  from "../components/updateInfo";
import CheckinBox from "../components/checkinBox";
import BreathingExercise from "../components/breathingExercise";
import MoodLogModal from "../components/moodlogmodal";
import MoodRing from "../components/moodring";
import WellnessScore from "../components/wellness-score";

// states_g
import { setgtMessage } from "../redux/gtmsgSlice";
import { gtNeutral } from "../redux/gtstatusSlice";
import { openModal, closeModal } from "../redux/moodmodalSlice";
import { setmodalgeneral } from "../redux/modalsSlice";

// hooks
import { useAppuserout } from "../hooks/general/useAppuserout";
import { useAiscore } from "../hooks/general/useAiscore";

// utilities
import { icons } from "../utilities/icn";
import { images } from "../utilities/img";
import { allQuestions } from "../utilities/allQuestions";
// import MoodMessage from "../components/moodmessage";


const Tracker = () => {  

    const navigate = useNavigate()
    const { checkAppUser } = useAppuserout()
    const { handleAiscore } = useAiscore()
    
    const user = useSelector((state) => state.user.value)
    const modalgeneral = useSelector((state) => state.modalgeneral.value)
    const showModal = useSelector((state) => state.showmodal.value)
    const moodadd = useSelector((state) => state.moodadd.value)
    
    const dispatch = useDispatch()
    
    const [windowWidth, setWindowWidth] = useState(window.innerWidth)
    const [breathingexercise, setbe] = useState(null)
    const [checkin, setcheckinbox] = useState(null)
    const [enterinfo, setEnterinfo] = useState(true)
    const [demodep, setdemodep] = useState(null)

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        // Cleanup: Remove the event listener when the component is unmounted
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    
    const setAlltoNull = () => {
        setEnterinfo(null)
        setcheckinbox(null)
        setbe(null)
        dispatch(closeModal())
        dispatch(setmodalgeneral(null))
    }



    return ( 

        <div className="tracker">

            {modalgeneral || showModal ?
                <BackDrop dropPress={setAlltoNull} />
            : null}

            <div className="flex justify-space-between row align-center mgb-30 track-head">
                
                <div className="flex row gap-20 align-center">
                    <h2 className="hn_medium d-white_c">Scope</h2>
                    <div className="stable-conn flex row gap-5 align-center">
                        <div></div>
                        <p className="hn_medium">Stable Connection</p>
                    </div>
                </div>

                <div className="flex row gap-30 align-center filter-row">

                    <div className="flex row gap-20 align-center">
                        <div className="flex row gap-10 cursor-pointer align-center">
                            <RefreshCcw size={25} color="rgba(30, 229, 233, 1)" />
                            <h3 className="hn_medium d-white_c">Refresh</h3>
                        </div>

                        <div className="flex row align-center">
                            <div className="filter-item flex justify-center align-center cursor-pointer active">
                                <h3 className="hn_medium d-white_c active">1m</h3>
                            </div>
                            <div className="filter-item flex justify-center align-center cursor-pointer">
                                <h3 className="hn_medium d-white_c">5m</h3>
                            </div>
                            <div className="filter-item flex justify-center align-center cursor-pointer">
                                <h3 className="hn_medium d-white_c">30m</h3>
                            </div>
                            <div className="filter-item flex justify-center align-center cursor-pointer">
                                <h3 className="hn_medium d-white_c">1h</h3>
                            </div>
                        </div>
                    </div>

                    <div className="filter-btn flex row align-center gap-5 cursor-pointer">
                        <SlidersHorizontal size={20} color="var(--d-white)" />
                        <h3 className="hn_medium d-white_c">Filter</h3>
                        <FaAngleDown size={15} color="var(--d-white)" />
                    </div>

                </div>

                <div className="quick-buy-box flex row align-center gap-10">
                    <h3 className="hn_medium d-white_c">Quick Buy:</h3>
                    <input type="number" placeholder="0.0" className="hn_medium d-white_c" />
                    <div></div>
                    <div className="flex row gap-5">
                        <h3 className="hn_medium d-white_c active">P1</h3>
                        <h3 className="hn_medium d-white_c">P2</h3>
                        <h3 className="hn_medium d-white_c">P3</h3>
                    </div>
                </div>

            </div>

            
        </div>

        
            


    );
}
 
export default Tracker;